module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inventory-add-page"
  }, [_c('div', {
    staticClass: "foo inventory-add-page__head"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_inventory_add_title')))]), _vm._v(" "), _c('p', {
    staticClass: "inventory-add-page__subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_inventory_add_subtitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "inventory-add-page__head-actions"
  }, [_c('button', {
    staticClass: "inventory-btn inventory-btn--ghost",
    on: {
      "click": _vm.toInventoryHistory
    }
  }, [_c('i', {
    staticClass: "ti-back-left"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_inventory_history')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "inventory-add-page__search inventory-add-page__panel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width inventory-add-page__panel"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_picture')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_current_stock_number')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_inventory_quantity')))])])]), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : (_vm.filteredItems.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_data')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredItems), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(_vm.normalizeImage(item)) ? _c('img', {
      staticClass: "user-avatar-sm cropped1",
      attrs: {
        "src": _vm.normalizeImage(item)
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(_vm.getDisplayName(item)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_current_stock_number')
      }
    }, [_vm._v(_vm._s(item.stockNumber))]), _vm._v(" "), _c('td', {
      staticClass: "inventory-add-page__qty-cell",
      attrs: {
        "data-title": _vm.locale.t('label_inventory_quantity')
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.inventoryQuantity),
        expression: "item.inventoryQuantity"
      }],
      staticClass: "form-control input inventory-add-page__qty-input",
      class: {
        'inventory-add-page__qty-input--error': _vm.isInvalidQuantity(item.inventoryQuantity)
      },
      attrs: {
        "type": "number",
        "min": "0",
        "step": "1"
      },
      domProps: {
        "value": (item.inventoryQuantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "inventoryQuantity", $event.target.value)
        }
      }
    })])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "inventory-add-page__footer-actions"
  }, [_c('div', {
    staticClass: "inventory-add-page__changes"
  }, [_vm._v(_vm._s(_vm.locale.t('label_items_count')) + ": "), _c('b', [_vm._v(_vm._s(_vm.payloadCount))])]), _vm._v(" "), _c('button', {
    staticClass: "inventory-btn inventory-btn--primary",
    attrs: {
      "disabled": _vm.saving || _vm.loading
    },
    on: {
      "click": _vm.saveInventory
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.saving ? _vm.locale.t('label_loading') : _vm.locale.t('label_confirm_inventory')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9008ea02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventory/AddNewInventory.vue
// module id = 805
// module chunks = 0